'use client'

import Script from 'next/script';
import { FC } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { DemoWidget, SnippetBlock } from '../widget-demo-shared/WidgetDocsSection';
import { runtimeConfig } from '@/lib/runtimeConfig';

const WIDGET_ATTRS: Record<string, string> = {
  'theme-radius': '0px',
  'theme-primary': '#dc1c2e',
  'theme-link': '#dc1c2e',
  'theme-font': 'Montserrat',
  'member-unique-code': 'wlas',
  'initial-tabs': 'TILE',
  'show-nav': 'false',
  'show-broker-info': 'true',
  'detail-as-modal': 'true',
  'show-page-size': 'false',
  'default-page-size': '6',
};

const SNIPPET_BODY = `
<alleimmobilien-wlas-widget
  theme-radius="0px"
  theme-primary="#dc1c2e"
  theme-link="#dc1c2e"
  theme-font="Montserrat"
  member-unique-code="wlas"
  initial-tabs="TILE"
  show-nav="false"
  show-broker-info="true"
  detail-as-modal="true"
  show-page-size="false"
  default-page-size="6"
/>`;

export const RemaxDemoScreen: FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Typography variant="h4" sx={{ mb: 1, fontWeight: 700 }}>
        alleimmobilien Widget Demo
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Beispiel-Integration des Immobiliensuch-Widgets im RE/MAX-Design.
      </Typography>

      <Box sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 2 }}>
        <Script src={`${runtimeConfig.WLAS_BASE_URL}alleimmobilien-wlas-widget.js`} strategy="afterInteractive" />
        <DemoWidget attrs={WIDGET_ATTRS} />
      </Box>

      <SnippetBlock snippetBody={SNIPPET_BODY} docsUrl={runtimeConfig.WLAS_BASE_URL} />
    </Container>
  );
};
